export const SEPARATOR = "__";

export function getLoadingNameByActionType(actionType) {
  if (typeof actionType === "string") {
    return actionType.split("/").join(SEPARATOR);
  } else if (actionType instanceof Array) {
    return actionType
      .map(item => item.split("/").join(SEPARATOR))
      .join(SEPARATOR);
  } else {
    console.error(`[vuex-loading] unknown action type: ${actionType}`);
  }
}
